export { default } from './CamHighlightsPlayer';
